import {useEffect,useRef} from 'react';
import {MicOff} from 'lucide-react';
import {Track,type Participant,type Track as MediaTrack} from 'livekit-client';
export function AttachedTrack({ track, muted = false, video = false, mirror = false }: { track: MediaTrack; muted?: boolean; video?: boolean; mirror?: boolean }) {
  const element = useRef<HTMLMediaElement | null>(null);
  useEffect(() => {
    const target = element.current;
    if (!target) return;
    track.attach(target); target.muted = muted;
    return () => { track.detach(target); };
  }, [track, muted]);
  return video ? <video autoPlay playsInline muted={muted} style={mirror ? { transform: 'scaleX(-1)' } : undefined} ref={node => {element.current=node;}}/> : <audio autoPlay ref={node => {element.current=node;}}/>;
}
export function Tile({ participant, self, screen = false }: { participant: Participant; self: boolean; screen?: boolean }) {
  const publication = participant.getTrackPublication(screen ? Track.Source.ScreenShare : Track.Source.Camera);
  return <div className={`call-tile${screen ? ' call-tile--screen' : ''}`}>
    {publication?.track && !publication.isMuted ? <AttachedTrack track={publication.track} video muted={self} mirror={self && !screen}/> : <div className="call-avatar">{(participant.name || 'Участник').split(' ').map(s=>s[0]).slice(0,2).join('')}</div>}
    <div className="call-tile-label">{participant.name || 'Участник'}{self ? ' · Вы' : ''}{screen ? ' · Экран' : ''}{!participant.isMicrophoneEnabled && <MicOff size={16}/>}</div>
  </div>;
}
export function mediaError(error: unknown) {
  const name = error instanceof Error ? error.name : '';
  if (name === 'NotAllowedError' || name === 'PermissionDeniedError') return 'Нет разрешения на микрофон или камеру. Разрешите доступ в настройках браузера или приложения.';
  if (name === 'OverconstrainedError') return 'Выбранная камера или микрофон недоступны. Откройте «Устройства» и выберите подключённое устройство.';
  if (name === 'NotFoundError') return 'Микрофон или камера не найдены. Проверьте подключение устройства.';
  if (name === 'NotReadableError') return 'Устройство занято другой программой. Освободите микрофон или камеру и повторите.';
  return error instanceof Error && !/token|jwt|wss:|ws:/i.test(error.message) ? error.message : 'Не удалось подключиться к звонку. Проверьте интернет и повторите.';
}
